import {
  SET_LIST_FAQ_DATA,
  SET_LIST_FAQ_DATA_TOTAL,
} from "../constant/actionTypes";

const initial_state = {
  listFaqData: null,
  listFaqDataTotal: 0,
};

export default (state = initial_state, action) => {
  switch (action.type) {
    case SET_LIST_FAQ_DATA:
      return {
        ...state,
        loading: false,
        listFaqData: action.listFaqData,
      };

    case SET_LIST_FAQ_DATA_TOTAL:
      return {
        ...state,
        loading: false,
        listFaqDataTotal: action.listFaqDataTotal,
      };

    default:
      return { ...state };
  }
};
